var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"user-chat-button"},[_c('button',{on:{"click":function($event){return _vm.$emit('open')}}},[_c('UserIcon',{attrs:{"name":_vm.id}}),_c('UserName',{attrs:{"name":_vm.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }